module.exports = __webpack_public_path__ + "static/media/stack-overflow_logo.9276690f.png";